import { render, staticRenderFns } from "./SageIconErroresTemplateComponent.vue?vue&type=template&id=779c15a0&scoped=true&lang=pug"
import script from "./SageIconErroresTemplateComponent.vue?vue&type=script&lang=ts"
export * from "./SageIconErroresTemplateComponent.vue?vue&type=script&lang=ts"
import style0 from "./SageIconErroresTemplateComponent.vue?vue&type=style&index=0&id=779c15a0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779c15a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('779c15a0')) {
      api.createRecord('779c15a0', component.options)
    } else {
      api.reload('779c15a0', component.options)
    }
    module.hot.accept("./SageIconErroresTemplateComponent.vue?vue&type=template&id=779c15a0&scoped=true&lang=pug", function () {
      api.rerender('779c15a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/grids/ColumnTemplates/SageIconErroresTemplateComponent.vue"
export default component.exports